import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAR8aE0-Sdnp6KatLg3kRgO-8jFx6LX3mA",
  authDomain: "pcas-jobportal.firebaseapp.com",
  projectId: "pcas-jobportal",
  storageBucket: "pcas-jobportal.appspot.com",
  messagingSenderId: "858520002310",
  appId: "1:858520002310:web:70719b30b1792c43160887",
  measurementId: "G-XCJJYCRZ7X",
  databaseURL:
    "https://pcas-jobportal-default-rtdb.asia-southeast1.firebasedatabase.app/",
});

const db = firebaseApp.database();
const auth = firebase.auth();
const storage = firebase.storage();
var gProvider = new firebase.auth.GoogleAuthProvider();

export { db, auth, storage, gProvider };
